import React, { FC } from 'react';
import VideoPlaceholder from './video';
import DisplayCaption from './caption';
import { CardTypes } from '../utils';

import {
  metaPropHandler,
  VideoContentUnitProps,
} from '../../nbc-jw-player/utils';

const {
  nbc: {
    brand,
    pdkAcct: accountId,
    host,
    twitterVia: twitter,
    callLetters,
    comscore_c4: station,
  },
} = window;

interface CardExpandedVideoProps {
  card: CardTypes;
}

const CardExpandedVideo: FC<CardExpandedVideoProps> = ({
  card,
  card: {
    summary,
  },
}) => (
  <div className="liveblog-card__expanded">
    <VideoPlaceholder
      video={{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        accountId,
        autoplay: true,
        brand,
        callLetters,
        excludeEndCard: true,
        host,
        station,
        twitter,
        videos: [{
          ...metaPropHandler(card as VideoContentUnitProps),
        }],
      }}
      position="lead"
    />
    {summary &&
      <DisplayCaption text={summary} />
    }
  </div>
);

export default CardExpandedVideo;
